var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.248 0.361328C18.159 0.361328 18.0676 0.377734 17.9762 0.415234L4.4668 5.84336H0.623047C0.416797 5.84336 0.248047 6.0168 0.248047 6.23242V13.2402C0.248047 13.4559 0.416797 13.6293 0.623047 13.6293H3.00664C2.91992 13.9012 2.87305 14.1895 2.87305 14.4824C2.87305 16.027 4.13398 17.2832 5.68555 17.2832C6.98398 17.2832 8.07852 16.402 8.40195 15.2113L17.9785 19.0598C18.0699 19.0949 18.1613 19.1137 18.2504 19.1137C18.6465 19.1137 19.0004 18.7809 19.0004 18.3355V1.13945C18.998 0.694141 18.6465 0.361328 18.248 0.361328ZM5.68555 15.6027C5.06445 15.6027 4.56055 15.1012 4.56055 14.4824C4.56055 14.2199 4.65195 13.9691 4.81836 13.7699L6.8082 14.5691C6.76133 15.1457 6.27617 15.6027 5.68555 15.6027ZM17.3105 16.9715L5.09492 12.0637L4.79258 11.9418H1.93555V7.53086H4.79258L5.09492 7.40898L17.3105 2.50117V16.9715Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.f77eb96fa218948fe1166bed01253d5c.svg";
export { ForwardRef as ReactComponent };